import { ListNumbersIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const NumberList = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ListNumbersIcon size={Sizes[size]} {...rest} color={fill} />;
};

NumberList.displayName = 'NumberList';
